/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// react
import { useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { Button } from "react-bootstrap"

// others
import Decimal from "decimal.js"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

// Kairos
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import {
  IsSearchingContext,
  GridInitializedContext,
  IsRestoreSearchingContext,
} from "../../../components/Context"
import CONSTANT from "../../../constant"
import {
  SearchResultContext,
  searchDyFromContext,
  searchDyToContext,
  searchBusyoCdContext,
  searchUnkoBusyoCdContext,
} from "./KaikonZyutyuHaisyaTableContext"
import {
  TKaikonZyutyuHaisyaListGetRes,
  TKaikonZyutyuHaisyaTableGetRes,
  TKaikonZyutyuHaisyaPrintHaisyahyoReq,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import { AppDispatch } from "../../.."
import KaikonZyutyuHaisyaService from "../../../service/orderContainer/kaikonZyutyuHaisya/kaikonZyutyuHaisyaService"

import {
  車輌乗務員Bindings,
  荷主Bindings,
  コンテナ情報Bindings,
  PICKBindings,
  作業Bindings,
  返却Bindings,
  その他Bindings,
  手当情報Bindings,
} from "./KaikonZyutyuHaisyaTableConstant"
import util from "../../../ts/util"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"

// #region [type]

export type T海コン配車表GridItem = TKaikonZyutyuHaisyaTableGetRes

export type T食事手当 = { name: string; value: number }

// #endregion

/**
 * 受注配車入力grid部
 * @param props
 * @returns
 */
const ZyutyuHaisyaListGrid: React.FC<{
  searchConditionClear?: React.MouseEventHandler<HTMLElement>
  gridId: string
}> = (props) => {
  // ロード表示
  const { setState: setIsSearching } = useContext(IsSearchingContext)
  //grid初期化フラグ
  const { state: gridInitialized, setState: setGridInitialized } = useContext(
    GridInitializedContext
  )
  // gridレストア完了フラグ
  const { state: isRestoreSearching, setState: setIsRestoreSearching } =
    useContext(IsRestoreSearchingContext)

  //#endregion
  // 検索結果
  const searchResult = useContext(SearchResultContext)

  const [forceUpdate, setForceUpdate] = useState(false)

  // 帳票出力条件
  const { state: 検索日From } = useContext(searchDyFromContext)
  const { state: 検索日To } = useContext(searchDyToContext)
  //const { state: 検索部所コード } = useContext(searchBusyoCdContext)
  const { state: 受注部所コード } = useContext(searchBusyoCdContext)
  const { state: 運行部所コード } = useContext(searchUnkoBusyoCdContext)

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TKaikonZyutyuHaisyaListGetRes>,
    pageSize: number
  ) => {
    return new wjCore.CollectionView<T海コン配車表GridItem>(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        受注No: (data: T海コン配車表GridItem) => {
          if (data.受注伝票番号 != null && data.受注伝票番号 !== "") {
            const text = `${data.受注伝票番号}${
              data.受注枝番 != null && data.受注枝番 > 0
                ? `-${data.受注枝番}`
                : ""
            }`
            return text
          } else {
            return ""
          }
        },
        padding車番: (data: T海コン配車表GridItem) =>
          util.createPadding車番(data.車番),
        乗務員売上: (data: T海コン配車表GridItem) =>
          new Decimal(data.PICK乗務員売上 ?? 0)
            .plus(data.作業乗務員売上 ?? 0)
            .plus(data.返却乗務員売上 ?? 0)
            .plus(data.その他乗務員売上 ?? 0)
            .toNumber(),
        食事手当: (data: T海コン配車表GridItem) =>
          new Decimal(data.PICK乗務員食事手当 ?? 0)
            .plus(data.作業乗務員食事手当 ?? 0)
            .plus(data.返却乗務員食事手当 ?? 0)
            .plus(data.その他乗務員食事手当 ?? 0)
            .toNumber(),
        特別手当: (data: T海コン配車表GridItem) =>
          new Decimal(data.PICK海コン特別手当 ?? 0)
            .plus(data.作業海コン特別手当 ?? 0)
            .plus(data.返却海コン特別手当 ?? 0)
            .plus(data.その他海コン特別手当 ?? 0)
            .toNumber(),
        付帯高速料: (data: T海コン配車表GridItem) =>
          new Decimal(data.PICK海コン付帯高速料 ?? 0)
            .plus(data.作業海コン付帯高速料 ?? 0)
            .plus(data.返却海コン付帯高速料 ?? 0)
            .plus(data.その他海コン付帯高速料 ?? 0)
            .toNumber(),
        付帯作業手当: (data: T海コン配車表GridItem) =>
          new Decimal(data.PICK海コン付帯作業手当 ?? 0)
            .plus(data.作業海コン付帯作業手当 ?? 0)
            .plus(data.返却海コン付帯作業手当 ?? 0)
            .plus(data.その他海コン付帯作業手当 ?? 0)
            .toNumber(),
      },
    })
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    // ヘッダー結合
    mergeHeader(grid)

    grid.refresh()
  }

  /**
   * ヘッダー結合処理
   */
  const mergeHeader = (grid: wjcGrid.FlexGrid) => {
    // header行に一行追加
    let extraRow = new wjcGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    columnHeaders.columns.forEach((c, index) => {
      if (c.binding != null) {
        let setHeaderText = ""
        if (車輌乗務員Bindings.includes(c.binding)) {
          setHeaderText = "車輌・乗務員"
        } else if (荷主Bindings.includes(c.binding)) {
          setHeaderText = "荷主"
        } else if (コンテナ情報Bindings.includes(c.binding)) {
          setHeaderText = "コンテナ情報"
        } else if (PICKBindings.includes(c.binding)) {
          setHeaderText = "PICK"
        } else if (作業Bindings.includes(c.binding)) {
          setHeaderText = "作業"
        } else if (返却Bindings.includes(c.binding)) {
          setHeaderText = "返却"
        } else if (その他Bindings.includes(c.binding)) {
          setHeaderText = "その他"
        } else if (手当情報Bindings.includes(c.binding)) {
          setHeaderText = "手当情報"
        } else {
          setHeaderText = c.header ?? ""
        }
        c.allowMerging = true
        columnHeaders.setCellData(0, index, setHeaderText)
      }
    })
  }

  /**
   * 海コン配車表印刷処理
   */
  const printHaisyahyo = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    const printCondition: TKaikonZyutyuHaisyaPrintHaisyahyoReq = {
      抽出条件_運行日From: 検索日From,
      抽出条件_運行日To: 検索日To,
      //抽出条件_部所コード: 検索部所コード,
      抽出条件_受注部所コード: 受注部所コード,
      抽出条件_運行部所コード: 運行部所コード,
    }

    try {
      const service = new KaikonZyutyuHaisyaService({ responseType: "blob" })
      const res = await service.printHaisyahyo(printCondition)
      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  //アラート制御
  //   const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [effect]

  useEffect(() => {
    if (searchResult == null) return

    setGridData({ data: createCollectionView(searchResult, pageSize) })
    flexGrid?.refresh()
    setIsSearching(false)
  }, [searchResult])

  //#endregion

  return (
    <>
      <input
        type="check"
        style={{ display: "none" }}
        value={forceUpdate ? 0 : 1}
        onChange={(e) => {
          setForceUpdate(e.currentTarget.checked)
        }}></input>
      <FlexGridOuter
        flexGrid={flexGrid}
        setFlexGrid={setFlexGrid}
        gridConstantProperties={CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
        gridData={gridData}
        setGridData={setGridData}
        pageNumber={pageNumber}
        searchConditionClear={props.searchConditionClear}
        gridId={props.gridId}
        isRestoreSearching={isRestoreSearching}
        isEnablePageSize={"hidden"}
        setIsRestoreSearching={setIsRestoreSearching}
        gridInitialized={gridInitialized}
        setGridInitialized={setGridInitialized}
        pageSize={pageSize}
        setPageSize={setPageSize}
        gridInitializedHandler={gridInitializedHandler}
        gridProperties={{
          frozenColumns: 4,
          isReadOnly: true,
          allowMerging: wjcGrid.AllowMerging.ColumnHeaders,
          headersVisibility: wjcGrid.HeadersVisibility.Column,
          keyActionTab: wjcGrid.KeyAction.CycleOut,
        }}
        headerComponent={
          <>
            <Button
              className="btn-done"
              onClick={() => {
                printHaisyahyo()
              }}
              disabled={searchResult == null || searchResult.length <= 0}>
              <FontAwesomeIcon icon={faFileAlt} />
              海コン配車表印刷
            </Button>
          </>
        }>
        {/* 車輌・乗務員 */}
        <wjrGrid.FlexGridColumn
          binding="車番"
          sortMemberPath={"padding車番"}
          width={80}
          header="車番"
          allowDragging={false}
          isRequired={false}></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="トレーラー車番"
          width={80}
          allowDragging={false}
          header="トレーラー"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="乗務員名"
          isRequired={false}
          width={120}
          allowDragging={false}
          header="乗務員"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="同乗乗務員名"
          isRequired={false}
          width={120}
          allowDragging={false}
          header="同乗乗務員名"></wjrGrid.FlexGridColumn>
        {/* 受注No */}
        <wjrGrid.FlexGridColumn
          binding="受注No"
          isReadOnly={true}
          cssClassAll={"read-only-cell"}
          width={110}
          header="受注No">
          <wjrGrid.FlexGridCellTemplate
            cellType={wjrGrid.CellTemplateType.ColumnHeader}
            template={() => (
              <div style={{ height: "100%" }}>受注No</div>
            )}></wjrGrid.FlexGridCellTemplate>
        </wjrGrid.FlexGridColumn>
        {/* 荷主 */}
        <wjrGrid.FlexGridColumn
          binding="荷主コード"
          width={80}
          dataType={wjCore.DataType.String}
          header="荷主CD"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="荷主略称1"
          width={200}
          header="荷主名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="表紙名"
          width={120}
          isRequired={false}
          header="表紙名"></wjrGrid.FlexGridColumn>
        {/* コンテナ情報 */}
        <wjrGrid.FlexGridColumn
          binding="荷主依頼番号"
          width={120}
          isRequired={false}
          dataType={wjCore.DataType.String}
          header="荷主依頼No"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="コンテナNO"
          width={120}
          dataType={wjCore.DataType.String}
          header="NO"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="コンテナサイズ名称1"
          width={80}
          dataType={wjCore.DataType.String}
          header="サイズ"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="コンテナ軸名称1"
          dataType={wjCore.DataType.String}
          width={80}
          header="軸"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="配車状態区分名称1"
          width={100}
          isRequired={false}
          header="作業状態"></wjrGrid.FlexGridColumn>
        {/* PICK */}
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先名称"
          isRequired={false}
          header="ヤード"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="PICK積卸先市区町村"
          isRequired={false}
          header="地名"></wjrGrid.FlexGridColumn>

        {/* 作業 */}
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業積卸先名称"
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業積卸先市区町村"
          header="地名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          isRequired={false}
          binding="作業内容"
          header="作業内容"></wjrGrid.FlexGridColumn>
        {/* 返却 */}
        <wjrGrid.FlexGridColumn
          binding="返却積卸先名称"
          isRequired={false}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="返却積卸先市区町村"
          isRequired={false}
          header="地名"></wjrGrid.FlexGridColumn>

        {/* その他 */}
        <wjrGrid.FlexGridColumn
          binding="その他積卸先名称"
          isRequired={false}
          header="社名"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="その他積卸先市区町村"
          isRequired={false}
          header="地名"></wjrGrid.FlexGridColumn>
        {/* 手当情報 */}
        <wjrGrid.FlexGridColumn
          binding="乗務員売上"
          width={150}
          dataType={wjCore.DataType.Number}
          header="乗務員売上"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="付帯作業手当"
          width={150}
          dataType={wjCore.DataType.Number}
          header="乗務員付帯料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="付帯高速料"
          width={150}
          dataType={wjCore.DataType.Number}
          header="付帯高速料"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="食事手当"
          width={150}
          dataType={wjCore.DataType.Number}
          header="食事手当"></wjrGrid.FlexGridColumn>
        <wjrGrid.FlexGridColumn
          binding="特別手当"
          width={150}
          dataType={wjCore.DataType.Number}
          header="特別手当"></wjrGrid.FlexGridColumn>
      </FlexGridOuter>
    </>
  )
}

export default ZyutyuHaisyaListGrid
